import React, { Fragment, ReactNode } from "react";
import { IntlProvider } from "react-intl";
import { LOCALES } from "./locales";
import messages from "./messages";

interface IProps {
  children: ReactNode;
  locale: string;
}

const INTLProvider = ({ children, locale = LOCALES.ENGLISH }: IProps) => {
  return (
    <IntlProvider
      locale={locale}
      textComponent={Fragment}
      messages={messages[locale]}
      onError={(err: any) => {
        if (err.code === "MISSING_TRANSLATION") {
          return;
        }
        throw err;
      }}
    >
      {children}
    </IntlProvider>
  );
};

export default INTLProvider;
